import React from 'react';

const SHOWN = 5;

/**
 * The NC plates of a filed bill were recorded, but a recipe unit kept some stock from moving.
 * The sale is done; this tells the owner which recipe to fix.
 */
export default function NcStockWarnings({ warnings }) {
    if (!Array.isArray(warnings) || warnings.length === 0) return null;
    return (
        <div style={{
            margin: '0 0 16px',
            padding: '10px 12px',
            backgroundColor: '#fffbeb',
            border: '1px solid #fcd34d',
            borderRadius: '8px',
            textAlign: 'left',
            fontSize: '13px',
            color: '#78350f',
            lineHeight: 1.5
        }}>
            <div style={{ fontWeight: 700, color: '#92400e', marginBottom: '4px' }}>
                Some NC stock was not deducted
            </div>
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
                {warnings.slice(0, SHOWN).map((message) => <li key={message}>{message}</li>)}
                {warnings.length > SHOWN && <li>…and {warnings.length - SHOWN} more</li>}
            </ul>
        </div>
    );
}
